import { defineComponent, reactive, watch, ref, getCurrentInstance } from "vue";
import { definePropType } from "@types-vue/props";
export default defineComponent({
    props: {
        schema: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        model: {
            type: definePropType(Object),
            required: true
        },
        layoutConfig: {
            type: definePropType(Array),
            default: function() {
                return [
                    24,
                    0
                ];
            }
        },
        refreshRouter: {
            type: Boolean,
            default: true
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var formModel = ref();
        var formConfig = reactive({
            inline: true,
            labelPosition: "left",
            labelWidth: ""
        });
        watch(function() {
            return props.model;
        }, function(val) {
            formModel.value = val;
        }, {
            immediate: true
        });
        var changeEvent = function() {
            emit("change");
        };
        var handleChange = function(prop) {
            // 不触发查询操作
            if (prop.formItem.noRefresh) {
                return false;
            }
            formModel.value["page"] = 1;
            if (props.refreshRouter) {
                root.$router.push({
                    query: prop.model
                });
            }
            changeEvent();
        };
        var inputChange = function(keyWord, key) {
            formModel.value[key] = keyWord;
            formModel.value["page"] = 1;
            if (props.refreshRouter) {
                root.$router.push({
                    query: formModel.value
                });
            }
            changeEvent();
        };
        var inputSelectChange = function(selectKeyWord, inputKeyWord, selectKey, inputKey) {
            formModel.value[selectKey] = selectKeyWord;
            formModel.value[inputKey] = inputKeyWord;
            formModel.value["page"] = 1;
            if (props.refreshRouter) {
                root.$router.push({
                    query: formModel.value
                });
            }
            changeEvent();
        };
        return {
            formConfig: formConfig,
            formModel: formModel,
            handleChange: handleChange,
            inputChange: inputChange,
            inputSelectChange: inputSelectChange
        };
    }
});
